const SIGN_IN = '/signin';
const SIGN_IN_PASSWORD_RECOVERY = '/signin/recover_password';
const SIGN_IN_CHANGE_PASSWORD = '/signin/change_password';
const SIGN_UP = '/signup';
const PAYMENT_GATEWAY = '/payment_gateway';
const MAINTENANCE = '/maintenance';
const ACCOUNTS = '/accounts';
const ACCOUNTS_DETAIL = '/accounts/detail';
const POINTS = '/points';
const POINTS_HISTORY = '/points_history';
const VOUCHERS = '/vouchers';
const BILLS = '/bills';
const BILLS_DETAIL = '/bills/detail';
const PAYMENTS = '/payments';
const EXTERNAL_PAYMENTS = '/external_payments';
const EXTERNAL_DOCUMENT_PAYMENTS = '/external_document_payments';
const CONFIGURATION = '/configuration';
const CLIENT_SUMMARY = '/client_summary';
const ACCOUNT_STATUS = '/';
const ACCOUNT_STATUS_PAGEVIEW = '/account_status';
const ENERGY_ADVISOR = '/advisor';
const CLAIMS = '/claims';
const COMPLAINTS = '/complaints';
const NEW_COMPLAINT = '/new_complaint';
const PROCEDURES = '/procedures';
const NEW_ACCOUNT_HOLDER_CHANGE = '/account_holder_change';
const NEW_TERMINATION_REQUEST = '/termination_request';
const REGISTER_ACCOUNT = '/register_account';
const SOCIAL_RATE = '/social_rate';
const ENERGY_ADVISOR_TIPS = '/tips';
const CHANGE_DUE_DATE = '/change_due_date';
const CHANGE_USER_INFO = '/change_user_info';
const PENDING_WARRANTY_DEPOSIT_QUERY = '/pending_warranty_deposit_query';
const PENDING_FINE_AMOUNT_QUERY = '/pending_fine_amount_query';
const NEW_FORM = '/new_form';
const PUBLIC_DASHBOARD = '/public';
const PUBLIC_HOME = '/public/home';
const PUBLIC_PAYMENTS_BY_NIS = '/public/payment_nis';
const PUBLIC_PAYMENTS = '/public/payments';
const PUBLIC_NIS_PAYMENTS = '/public/pay';
const PUBLIC_PAYMENT_DOCUMENTS = '/public/payment_documents';
const PUBLIC_COMPLAINTS = '/public/complaints';
const PUBLIC_SOCIAL_RATE = '/public/social_rate';
const PUBLIC_NEW_COMPLAINT = '/public/new_complaint';
const PUBLIC_LAST_BILL_QUERY = '/public/last_bill_query';
const PUBLIC_BALANCE_QUERY = '/public/balance_query';
const PUBLIC_CHANGE_DUE_DATE = '/public/change_due_date';
const PUBLIC_PENDING_WARRANTY_DEPOSIT_QUERY = '/public/pending_warranty_deposit_query';
const PUBLIC_PENDING_FINE_AMOUNT_QUERY = '/public/pending_fine_amount_query';
const PUBLIC_PAYMENT_REQUEST = '/public/payment_request';
const PAYMENT_REQUEST = '/payment_request';
const PAYMENT_SUCCESS = '/payment_result/success';
const PAYMENT_FAILURE = '/payment_result/failure';
const PAYMENT_RESULT = '/payment_result';
const ENTITIES_COMPLAINTS = '/entidades/denuncias';
const MY_TURNS = '/my_turns';
const NEW_TURN = '/new_turn';

export const ROUTES = {
  SIGN_IN,
  SIGN_IN_PASSWORD_RECOVERY,
  SIGN_IN_CHANGE_PASSWORD,
  SIGN_UP,
  PAYMENT_GATEWAY,
  MAINTENANCE,
  ACCOUNTS,
  ACCOUNTS_DETAIL,
  POINTS,
  POINTS_HISTORY,
  VOUCHERS,
  BILLS,
  BILLS_DETAIL,
  PAYMENTS,
  EXTERNAL_PAYMENTS,
  EXTERNAL_DOCUMENT_PAYMENTS,
  CONFIGURATION,
  CLIENT_SUMMARY,
  ACCOUNT_STATUS,
  ACCOUNT_STATUS_PAGEVIEW,
  ENERGY_ADVISOR,
  CLAIMS,
  COMPLAINTS,
  NEW_COMPLAINT,
  PROCEDURES,
  MY_TURNS,
  NEW_TURN,
  NEW_ACCOUNT_HOLDER_CHANGE,
  NEW_TERMINATION_REQUEST,
  REGISTER_ACCOUNT,
  SOCIAL_RATE,
  ENERGY_ADVISOR_TIPS,
  CHANGE_DUE_DATE,
  CHANGE_USER_INFO,
  PENDING_WARRANTY_DEPOSIT_QUERY,
  PENDING_FINE_AMOUNT_QUERY,
  NEW_FORM,
  PUBLIC_DASHBOARD,
  PUBLIC_HOME,
  PUBLIC_PAYMENTS,
  PUBLIC_PAYMENTS_BY_NIS,
  PUBLIC_NIS_PAYMENTS,
  PUBLIC_PAYMENT_DOCUMENTS,
  PUBLIC_COMPLAINTS,
  PUBLIC_SOCIAL_RATE,
  PUBLIC_NEW_COMPLAINT,
  PUBLIC_LAST_BILL_QUERY,
  PUBLIC_BALANCE_QUERY,
  PUBLIC_CHANGE_DUE_DATE,
  PUBLIC_PENDING_WARRANTY_DEPOSIT_QUERY,
  PUBLIC_PENDING_FINE_AMOUNT_QUERY,
  PUBLIC_PAYMENT_REQUEST,
  PAYMENT_REQUEST,
  PAYMENT_RESULT,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  ENTITIES_COMPLAINTS
};

export const ROUTE_TYPES = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  RESTRICTED: 'restricted'
};

export const DEFAULT_ROUTES = {
  RETRIEVE_SESSION: ROUTES.SIGN_IN,
  PRIVATE: ROUTES.ACCOUNT_STATUS,
  RESTRICTED: ROUTES.SIGN_IN
};

export const PUBLIC_ROUTES = [
  ROUTES.SIGN_IN_CHANGE_PASSWORD,
  ROUTES.SIGN_UP,
  ROUTES.PAYMENT_GATEWAY,
  ROUTES.MAINTENANCE,
  ENTITIES_COMPLAINTS,
  NEW_FORM,
  PAYMENT_RESULT,
  PUBLIC_NIS_PAYMENTS,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE
];

export const RESTRICTED_ROUTES = [
  ROUTES.SIGN_IN,
  ROUTES.SIGN_IN_PASSWORD_RECOVERY,
  PUBLIC_DASHBOARD,
  PUBLIC_HOME,
  PUBLIC_PAYMENTS,
  PUBLIC_PAYMENTS_BY_NIS,
  PUBLIC_PAYMENT_DOCUMENTS,
  PUBLIC_COMPLAINTS,
  PUBLIC_SOCIAL_RATE,
  PUBLIC_NEW_COMPLAINT,
  PUBLIC_LAST_BILL_QUERY,
  PUBLIC_BALANCE_QUERY,
  PUBLIC_CHANGE_DUE_DATE,
  PUBLIC_PENDING_WARRANTY_DEPOSIT_QUERY,
  PUBLIC_PENDING_FINE_AMOUNT_QUERY,
  PUBLIC_PAYMENT_REQUEST
];
